<template src="./Index.html"></template>

<script>
export default {
  components: {},
  created() {
    this.$store.dispatch("lookups/getJobGrades");
    this.getAll();
    this.$store.dispatch("lookups/getLookups");
  },
  computed: {
    jobGrades() {
      return this.$store.state.lookups.jobGrades;
    },
      correlators() {
          return [
              { value: null, label: "0" },
              { value: 1, label: "1" },
              { value: 2, label: "2" },
              { value: 3, label: "3" },
              { value: 4, label: "4" },
              { value: 5, label: "5" },
              { value: 6, label: "6" },
              { value: 7, label: "7" },
              { value: 8, label: "8" },
              { value: 9, label: "9" },
              { value: 10, label: "10" },

          ]
    
    },
 
    pageCount() {
      return Math.ceil(
        this.totalItems /
          this.filters.pageSize
      );
    },
  },
  data() {
    return {
       subtitle:"",
      items: [
          {
            text: "التقارير",
        },
        {
          text: "تقرير البيانات الوظيفية ",
        },       
      ],
      itemId: 0,
      view: 0,
      data: [],
      totalItems: 0,
      filters: {
        page: 1,
        pageSize: 10,
        jobGradeId: null,
        correlatorId: null,
     
      },
      headers: [
        {
          text: "الرقم التسلسلي ",
          value: "employeeNo",
          sortable: false,
          align: "start",
        },
        {
          text: "اسم الموظف",
          value: "fullName",
          sortable: false,
          align: "start",
        },
         {
          text: "تاريخ التوظيف",
          value: "employmentDate",
          sortable: false,
          align: "start",
        },   {
          text: "تاريخ المباشرة",
          value: "startingDate",
          sortable: false,
          align: "start",
        },
      { text: "الدرجة الوظيفية الحالية", value: "jobGradeName", sortable: false },     
      { text: "تاريخ الحصول عليها", value: "jobGradeDate", sortable: false },     
      { text: "المربوط الحالية", value: "currentCorrelatorId", sortable: false },     
      { text: "تاريخ الحصول عليه", value: "correlatorDate", sortable: false },     

        {
          text: "الادارة / الفرع",
          value: "administrationName",
          sortable: false,
          align: "start",
        },
        {
          text: "القسم ",
          value: "departmentName",
          sortable: false,
          align: "start",
        },   
           {
          text: "الوحدة ",
          value: "unitName",
          sortable: false,
          align: "start",
        },      
      ],
    };
  },
  methods: {
    
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("reports/getCorrelator", this.filters).then((res)=>{
        this.data = res.data;
        this.totalItems = res.totalItems;
      });
    },
    download() {
      let filters = {
        jobGradeId: this.filters.jobGradeId,
        correlatorId: this.filters.correlatorId,
       
      };
      const paramsString = Object.entries(filters)
        .filter(([, val]) => val !== null)
        .map(([key, val]) => `${key}=${val}`)
        .join("&");
      window.open(`/api/reports/correlatorExcel?${paramsString}`, "_blank");
    },

  },
};
</script>
